import { MdCall, MdEmail } from "react-icons/md";
import { FaRegAddressCard } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoLogoWhatsapp } from "react-icons/io";

const contactInfo = [
  {
    icon: <IoLogoWhatsapp size={40} className="text-Orange" />,
    title: "Chat With Us",
    content: "+91 8977918777",
    link: "tel:+918977918777",
  },
  {
    icon: <MdEmail size={40} className="text-Orange" />,
    title: "Email Us",
    content: "customer@newdirections.org.in",
    link: "mailto:customer@newdirections.org.in",
  },
  {
    icon: <FaRegAddressCard size={40} className="text-Orange" />,
    title: "Visit Us",
    content:
      "Plot No.59, Brindavan Colony, A. S. Rao Nagar, ECIL, Hyderabad, Secunderabad, Telangana 500062",
    link: "https://www.google.co.in/maps/@17.4816458,78.5587343,3a,90y,211.13h,92.17t/data=!3m6!1e1!3m4!1sG_1f65Gy9td9HbmS1E-k3A!2e0!7i13312!8i6656?entry=ttu",
  },
];

const CTA = () => {
  return (
    <div className="flex flex-wrap lg:flex-nowrap my-7 lg:my-14 flex-row gap-4 lg:gap-3  xl:gap-8 rounded mx-3 lg:mx-8">
      {contactInfo.map((item, index) => (
        <div
          key={index}
          className="flex gap-2 lg:gap-1 xl:gap-5 items-center h-36 p-3 xl:p-7 border-s-2 border-b-2 border-Orange shadow-md rounded-full flex-1 min-w-[280px]"
        >
          <Link to={item.link} target="_blank">
            <div className="bg-Orange/10 p-2 xl:p-4 shadow-lg rounded-full hover:scale-105 transition-transform duration-300">
              {item.icon}
            </div>
          </Link>
          <div className="grid grid-cols-1 gap-2 place-content-center">
            <h4 className=" text-lg lg:text-xl text-Orange font-semibold">
              {item.title}
            </h4>
            <Link
              to={item.link}
              target="_blank"
              className="text-sm xxs:text-base"
            >
              <p className="text-darkGray">{item.content}</p>{" "}
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CTA;
